import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useRef } from 'react';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const G: React.FC = () => {
    const { t } = useLang('ats.G');
    const webpOrJpg = useWebpOrJpg('#smart-gateway-G');

    /** 动画 */
    const infoRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const label = infoRef.current?.querySelector('.label');
        const title = infoRef.current?.querySelector('.title');
        const desc = infoRef.current?.querySelector('.desc');
        const ani1 = AniContainer.create({
            triggerElement: infoRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                label?.classList.add('enter');
                title?.classList.add('enter');
                desc?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    label?.classList.remove('enter');
                    title?.classList.remove('enter');
                    desc?.classList.remove('enter');
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);
    return (
        <section
            className={`${css.section} smart-gateway-G GtmModuleData-section`}
            id="smart-gateway-G"
            data-section-id={'smart-gateway-G'}
            data-section-title={t('title')}
        >
            <div className="item-img">
                <EcoImg
                    pc={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1760151344628/pc_Compatible%20with%20High-Power%20Generators.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1760151354353/pc_Compatible.webp',
                    )}
                    h5={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1760151344330/m_Compatible%20with%20High-Power%20Generators.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1760151353991/m_Compatible.webp',
                    )}
                />
            </div>
            <div className="info" ref={infoRef}>
                <div className="box">
                    <div className="label-ani">
                        <p className={`label ani-1`}>{t('label')}</p>
                    </div>
                    <div className="title-ani">
                        <p className={`title ani-2`}>{t('title')}</p>
                    </div>
                </div>
                <div className="desc-ani">
                    <p className={`desc ani-2-5`}>
                        {t.rich('desc', {
                            h: (a: string) => <span className="white">{a}</span>,
                        })}
                    </p>
                </div>
            </div>
        </section>
    );
};

export default G;
